export default function join(
  ...classes: Array<string | string[] | undefined>
): string {
  return classes.flat().filter(Boolean).join(' ');
}
